<template>
  <div class="aplication_container">
    <!-- <van-sticky> -->
    <van-tabs v-model="activeStatusId"
              lazy-render
              class="shop_keep_tab"
              @change="onChange">

      <van-tab v-for="(tab,index) in applyStatusList"
               :key="index"
               :name="tab.name">
        <!-- 自定义图标-->
        <template #title> {{tab.title}} <div id="tab_title"> <van-badge :content="tab.count"
                       v-if="tab.count>0" /></div></template>
      </van-tab>

    </van-tabs>
    <!-- </van-sticky> -->
    <!-- tab切换内容 -->
    <div>
      <div>
        <div v-if="applyList.length > 0">
          <van-list v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了~"
                    error-text="加载失败,请重试!"
                    @load="onLoad">
            <div class="mine_apply_box">
              <div class="mine_apply_content">
                <div class="mine_box"
                     v-for="(item,index) in applyList"
                     :key="index">
                  <div class="mine_apply_main">
                    <!-- 左侧 -->
                    <div class="mine_apply_left">
                      <div class="min_apply_name">申请人姓名：{{item.mallUserName}}</div>
                      <div class="mine_apply_time">申请人手机：{{item.phoneNumber}}</div>
                      <div class="mine_apply_time">申请时间：{{item.applyTime}}</div>
                      <div class="mine_apply_time"
                           v-if="activeStatusId == '1'">审核时间：{{item.passTime}}</div>
                    </div>
                    <!-- 右侧 -->
                    <!-- tab1 待审核 -->
                    <div v-if="activeStatusId == '0'"
                         style="align-self:center;">
                      <div>
                        <van-button type="primary"
                                    class="agree"
                                    @click="agreeAplication(item)"
                                    size=small>通过</van-button>
                      </div>
                      <div>
                        <van-button type="danger"
                                    class="agree disAgree"
                                    @click="disAgreeAplication(item.id)"
                                    size=small>不通过</van-button>
                      </div>
                    </div>
                    <!-- tab2 审核通过 -->
                    <div class="mine_apply_status"
                         v-if="item.examinedStatus == 1 && activeStatusId == '1'">审核中</div>
                    <div class="mine_apply_status pass"
                         v-if="item.examinedStatus == 4 && activeStatusId == '1'">审核通过</div>
                    <div class="mine_apply_status finished"
                         v-if="item.examinedStatus == 2 && activeStatusId == '1'">审核完成待通过</div>
                    <!-- tab3 审核不通过 -->
                    <div style="align-self:center;"
                         v-if="activeStatusId == '2'">
                      <div class="fail">审核不通过</div>
                      <div class="reason"
                           @click="viewReason(item.errorCause)">查看原因<van-icon name="arrow"
                                  id="icon" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>

    </div>
    <!--空状态 -->
    <div class="noOrders"
         v-if="applyList.length == 0 ">

      <img src="../../../assets/images/keepEmpty.png"
           alt />

      <div>暂无申请信息</div>

    </div>
    <!-- 加载中 -->
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>

    <!-- 不同意弹窗 -->
    <van-dialog v-model="showDisagreeDialog"
                @confirm="disConfirm"
                title="审核不通过原因"
                :showConfirmButton='true'
                :showCancelButton='true'>
      <van-field v-model="errorSource"
                 id="textArea"
                 rows="2"
                 autosize
                 type="textarea"
                 maxlength="50"
                 placeholder="请输入留言"
                 show-word-limit />
    </van-dialog>
    <!-- 同意弹窗 -->
    <van-overlay :show="showDialog"
                 v-if="showDialog">
      <div class="wrappers"
           @click.stop>
        <p>审核声明</p>
        <van-icon name="cross"
                  class="wrapper_icon"
                  @click="closeIcon()"
                  size="15" />
        <div>确认通过即代表此会员<span>{{item.mallUserName}}{{item.phoneNumber}}</span>审核通过，需已确认该会员满足审核通过条件。若未满足条件即让其通过审核，所产生的任何后果需您本人承担，特此声明。</div>
        <van-button type="default"
                    v-if="!btnFlag"
                    class="wrapper_button">{{duration}}秒后可操作</van-button>
        <van-button type="default"
                    v-if="btnFlag"
                    @click="sure()"
                    class="wrapper_buttons"
                    :loading='isLoading'>确认通过</van-button>
      </div>

    </van-overlay>
  </div>
</template>

<script>

import {
  Tab,
  Tabs,
  Card,
  Button,
  Panel,
  Dialog,
  Toast,
  List,
  PullRefresh,
  Loading,
  Notify,
  Form,
  Field,
  Overlay,
  Popup,
  Badge,
  Icon,
  Sticky
} from "vant";
import loading from "../../components/loading/loading";
import serviceUser from "../../api/user/index";
import serviceApply from "../../api/apply/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    [Badge.name]: Badge,
    [Icon.name]: Icon,
    [Sticky.name]: Icon,
    loading
  },
  props: {},
  data () {
    return {
      status: false,
      activeStatusId: '0',
      applyStatusList: [
        { name: "0", title: "待审核", count: '0' },
        { name: "1", title: "审核通过", count: '0' },
        { name: "2", title: "审核不通过", count: '0' },
      ],
      applyList: [],
      firstLoading: false,
      //加载中loading
      isLoading: false,
      // 加载更多分页
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      // Tab 状态
      status: '0',
      // 不同意弹窗标识
      showDisagreeDialog: false,
      // 同意弹窗标识
      showDialog: false,
      // 不通过原因
      errorSource: '',
      // 申请明细id
      id: '',
      // 同意数据
      item: {},
      // 倒计时
      duration: 5,
      timer: null,
      btnFlag: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 同意申请
    agreeAplication (item) {
      this.item = item
      this.id = item.id
      this.showDialog = true
      this.countDown()
    },
    // 确认同意按钮
    sure () {

      this.aplicationStatus(0)
    },
    closeIcon () {
      this.resetData()
      this.showDialog = false
    },
    // 重置倒计时
    resetData () {
      clearInterval(this.timer);
      this.btnFlag = false
      this.duration = 5
    },
    // 倒计时
    countDown () {
      this.timer = setInterval(() => {
        this.duration--;
        if (this.duration <= 0) {
          this.btnFlag = true
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 不同意
    disAgreeAplication (id) {
      this.id = id
      this.errorSource = '抱歉，您未满足审核通过条件'
      this.showDisagreeDialog = true
    },
    disConfirm () {
      this.showDisagreeDialog = false
      this.aplicationStatus(1)
    },
    // 同意/不同意接口
    aplicationStatus (status) {
      this.isLoading = true
      const postData = {
        status: status, //审核状态 0.通过 1.不通过
        id: this.id,
        errorSource: this.errorSource
      }
      serviceApply
        .processApply(postData)
        .then((res) => {
          if (res.statusCode == 200) {

            this.isLoading = false
            if (res.data == true) {
              this.resetData()
              if (status == 0) {
                this.showDialog = false
              }
              this.getKeeperCount()
              this.applyList = []
              this.page = 1
              this.onLoad()
            } else {

            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // tab 切换
    onChange (activeStatusId) {
      this.page = 1
      this.applyList = []
      if (activeStatusId == '0') {
        this.status = '0'
      } else if (activeStatusId == '1') {
        this.status = '1'
      } else if (activeStatusId == '2') {
        this.status = '2'
      }
      this.isLoading = false
      this.finished = false
      this.isLoading = true
      this.onLoad()
    },
    // 获取待审核数量
    getKeeperCount () {
      this.isLoading = true
      return serviceUser
        .applyCount()
        .then((res) => {
          if (res.statusCode == 200) {
            if (res.data <= 99) {
              console.log(this.applyStatusList[0]);
              this.applyStatusList[0].count = res.data
            } else {
              this.applyStatusList[0].count = '99+'
            }
            return res
          } else {
            Toast(errors);
          }

        })
        .catch((err) => {
          Toast(err);
        });
    },
    // promise all 统一处理loading(第一个tab)
    getData () {
      Promise.all([this.getKeeperCount()]).then(res => {
        // console.log(res);
        this.isLoading = false
      })
    },
    //下拉加载列表
    onLoad () {
      // if (this.applyList.length == 0 && this.loading == true) {
      // this.isLoading = true
      // }
      try {
        serviceApply
          .processList(this.page, this.pageSize, this.status)
          .then((res) => {
            if (res.statusCode == 200) {
              const results = res.data.items
              this.applyList.push(...results)
              this.isLoading = false
              this.loading = false;
              if (results.length) {
                // 有，则更新获取下一个数据的页码
                this.page++
              } else {
                // 没有，则将加载状态finished设置为结束
                this.finished = true
              }
            } else {
              this.isLoading = false
              Toast(errors);
            }

          })
          .catch((err) => {
            this.isLoading = false
            Toast(err);
          });
      } catch (errors) {
        this.isLoading = false
        Toast(errors);

      } finally {
        this.isLoading = false
      }
    },
    // onLoad () {
    //   // 异步更新数据
    //   // setTimeout 仅做示例，真实场景中一般为 ajax 请求
    //   setTimeout(() => {
    //     for (let i = 0; i < 10; i++) {
    //       this.applyList.push(this.applyList.length + 1);
    //     }

    //     // 加载状态结束
    //     this.loading = false;

    //     // 数据全部加载完成
    //     if (this.list.length >= 20) {
    //       this.finished = true;
    //     }
    //   }, 1000);
    // },

    // 修改我的数量接口
    applyCount () {
      this.isLoading = true
      return serviceApply
        .applyCount()
        .then((res) => {
          if (res.statusCode == 200) {
            this.isLoading = false
            if (res.data === true) {
              this.getKeeperCount()
            }
          } else {
            Toast(errors);
          }
          return res
        })
        .catch((err) => {
          Toast(err);
        });
    },
    // 查看原因
    viewReason (reason) {
      Dialog.alert({
        title: '审核不通过原因',
        message: reason,
        messageAlign: 'center',
        confirmButtonText: '我知道了'
      }).then(() => {
        // on close
      });
    }
  },
  created () { },
  mounted () {
    //获取未读数量和
    this.getData()
    this.onLoad()
  }
};
</script>
<style lang="less" >
@deep: ~'>>>';
.aplication_container {
  width: 100%;
  position: relative;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 60px;
  .van-list__error-text,
  .van-list__finished-text,
  .van-list__loading {
    line-height: 16px;
  }
  .noOrders {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-top: 0;
  }
  .shop_keep_tab {
    // height: 48px;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2;
  }
  .van-tabs__wrap {
    height: 48px;
  }
  .van-tab {
    height: 48px !important;
  }
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }
  // @{deep} .van-info {
  //   right: -10px !important;
  // }
  #tab_title {
    position: absolute;
    top: 8px;
    right: 21px;
  }
  .mine_apply_box {
    // min-height: calc(100vh - 48px);
    padding: 0 16px;
    .mine_apply_content {
      padding: 0 0 16px 0;
      overflow: hidden;
      .mine_box {
        min-height: 48px;
        background: #ffffff;
        box-shadow: 0px 4px 8px 1px #ebebeb;
        border-radius: 8px 8px 8px 8px;
        margin-top: 8px;
        border: 1px solid #e6e6e6;
        padding: 16px 12px;
      }
      .mine_apply_main {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .mine_apply_left {
          font-size: 14px;
          color: #333333;
          line-height: 14px;
          .min_apply_name {
            width: 200px;
            height: 20px;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .mine_apply_time {
            height: 20px;
            line-height: 20px;
            margin-top: 8px;
          }
        }
        .mine_apply_status {
          align-self: center;
          color: #f28424;
        }
        .pass {
          color: rgba(39, 180, 95, 1);
        }
        .finished {
          color: rgba(242, 132, 36, 1);
        }
        .fail {
          color: rgba(240, 7, 36, 1);
        }
        .reason {
          margin-top: 8px;
          position: relative;
          color: rgba(153, 153, 153, 1);
          #icon {
            // vertical-align: middle;
            // margin-top: 3px;
            position: absolute;
            top: 3px;
            display: inline-block;
          }
        }
      }
      .mine_box:first-child {
        margin-top: 64px;
      }
      .mine_apply_down {
        height: 25px;
        border-top: 1px solid #e6e6e6;
        margin-top: 16px;
        p {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.4);
          line-height: 14px;
        }
      }
    }
  }
  .agree {
    width: 72px !important;
    height: 32px !important ;
  }
  .disAgree {
    margin-top: 8px;
  }
  .van-field__value {
    width: 295px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f2f2f2;
    margin-top: 24px 16px 24px 16px;
    padding: 9px 16px;
  }
  .wrappers {
    text-align: center;
    width: 278px;
    min-height: 198px;
    padding: 24px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 1px rgba(0, 0, 0, 0.05);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    position: fixed;
    top: 45%;
    left: 50%;
    overflow: hidden;
    font-size: 4.26667vw;
    background-color: #fff;
    border-radius: 4.26667vw;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    -webkit-transition-property: opacity, -webkit-transform;
    transition-property: opacity, -webkit-transform;
    transition-property: transform, opacity;
    transition-property: transform, opacity, -webkit-transform;
    p {
      padding: 0;
      margin: 0;
      color: #000000;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 24px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
    .wrapper_icon {
      position: absolute;
      right: 16px;
      top: 24px;
    }
    div {
      text-align: left;
      line-height: 22px;
      font-size: 14px;
      color: #000000;
      span {
        color: rgba(240, 7, 36, 1);
      }
    }
    .wrapper_button {
      width: 263px;
      height: 40px;
      background: #dcdcdc;
      border-radius: 4px 4px 4px 4px;
      margin-top: 24px;

      .van-button__text {
        color: #ffffff;
      }
    }
    .wrapper_buttons {
      width: 263px;
      height: 40px;
      background: rgba(240, 7, 36, 1);
      border-radius: 4px 4px 4px 4px;
      margin-top: 24px;
      .van-button__text {
        color: #ffffff;
      }
    }
  }
}
</style>